module.exports = __webpack_public_path__ + "static/media/jobreellogo200.6a887d87.png";